/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth } from './FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth';
import {
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSON,
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSONTyped,
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSON,
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSONTyped,
} from './FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth';
import type { FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId } from './FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId';
import {
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSON,
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSONTyped,
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSON,
    FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSONTyped,
} from './FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId';

/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderAuthOptions
 */
export interface FxIdApplicationPublicDataBuilderAuthOptions {
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth}
     * @memberof FxIdApplicationPublicDataBuilderAuthOptions
     */
    VkontakteComOauth?: FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth | null;
    /**
     * 
     * @type {FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId}
     * @memberof FxIdApplicationPublicDataBuilderAuthOptions
     */
    VkontakteComVkId?: FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkId | null;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderAuthOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderAuthOptions(value: object): value is FxIdApplicationPublicDataBuilderAuthOptions {
    return true;
}

export function FxIdApplicationPublicDataBuilderAuthOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderAuthOptions {
    return FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderAuthOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderAuthOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'VkontakteComOauth': json['VkontakteComOauth'] == null ? undefined : FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSON(json['VkontakteComOauth']),
        'VkontakteComVkId': json['VkontakteComVkId'] == null ? undefined : FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdFromJSON(json['VkontakteComVkId']),
    };
}

export function FxIdApplicationPublicDataBuilderAuthOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderAuthOptions {
    return FxIdApplicationPublicDataBuilderAuthOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderAuthOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderAuthOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'VkontakteComOauth': FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSON(value['VkontakteComOauth']),
        'VkontakteComVkId': FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComVkIdToJSON(value['VkontakteComVkId']),
    };
}

